import { filter, sortBy } from "lodash";
import { containsCoordinate } from "ol/extent";
import * as olProj from "ol/proj";

export const handleSearchChange = (val) => {
  // once typing begins, clear the value we persist when moving away from the filter input.
  return [
    {
      persistFilterValue: "",
      nextChunk: 1,
    },
    val.trim().toLowerCase(),
  ];
};

export const handleFilterDeletion = (filterType, val, filters) => {
  let newstate;
  switch (filterType) {
    case "noteTag":
      let { noteTags } = filters;
      noteTags = noteTags.filter(
        (d) => d.category !== val.category || d.note !== val.note
      );
      newstate = { ...filters, noteTags };
      break;

    default:
      newstate = { ...filters, [filterType]: null };
  }

  return newstate;
};

export const filterAndSortItems = (items, filters, sortDsc = false) => {
  //KEYWORD FILTER
  if (filters.keyword && filters.keyword.length) {
    items = filterItemsByKeyword(items, filters.keyword, filters.searchFields);
  }

  //now handle tags
  if (filters.noteTags && filters.noteTags.length) {
    filters.noteTags.forEach((d) => {
      items = filterItemsByNoteTag(items, d);
    });
  }

  if (filters.bounds && filters.bounds.length) {
    items = items.filter((item) => {
      try {
        return containsCoordinate(
          filters.bounds,
          olProj.fromLonLat([
            parseFloat(item.lon || item.longitude),
            parseFloat(item.lat || item.latitude),
          ])
        );
      } catch (e) {
        return false;
      }
    });
  }

  //now handle sort
  if (filters.sortBy && filters.sortBy.length) {
    items = sortItems(items, filters.sortBy, filters.sortDsc);
  }

  return items;
};

const addNotesToNotesString = (obj, notesList) => {
  let notesString = "";
  let objNotes = obj[notesList];
  if (Array.isArray(objNotes)) {
    objNotes.forEach((d) => {
      notesString += ` ${String(d.category)} ${d.note ? String(d.note) : ""}`;
    });
  }
  return notesString;
};

const filterItemsByKeyword = (items, keyword, fields) => {
  const predicate = (obj) => {
    obj.noteString = "";
    obj.noteString += addNotesToNotesString(obj, "notes");
    obj.noteString += addNotesToNotesString(obj, "turfnotes");

    /// only search in some fields to speed up the process
    for (const idx in fields) {
      const v = obj[fields[idx]];

      const coercedValue = String(v);

      if (coercedValue.trim().toLowerCase().includes(keyword.toLowerCase())) {
        return true;
      }
    }
    return false;
  };

  return filter(items, predicate);
};

export const sortItems = (items, sortOrder, sortDsc) => {
  let predicate;
  if (sortOrder == "note_count") {
    predicate = (siteObj) => (siteObj.notes || []).length;
  } else if (sortOrder === "seat_count") {
    predicate = (siteObj) => (siteObj.routeseats || []).length;
  } else if (sortOrder === "status") {
    let statuses = ["checked_in", "not_checked_in", "unscheduled"];
    let orderedSites = [
      ...items.filter((c) => c.status === statuses[0]),
      ...items.filter((c) => c.status === statuses[1]),
      ...items.filter((c) => c.status === statuses[2]),
    ];

    if (sortDsc) {
      return orderedSites.reverse();
    }
    return orderedSites;
  } else if (sortOrder === "cut") {
    predicate = (siteObj) =>
      siteObj.household_count / (siteObj.walkable_cut + siteObj.unwalkable_cut);
  } else {
    predicate = (siteObj) => {
      return typeof siteObj[sortOrder] === "string"
        ? siteObj[sortOrder].toLowerCase()
        : siteObj[sortOrder];
    };
  }

  if (sortDsc) {
    return sortBy(items, predicate).reverse();
  }

  return sortBy(items, predicate);
};

export const filterItemsByNoteTag = (items, noteTagFilter) => {
  const predicate = (obj) => {
    // must check if notes is a string or array
    // because turfs used to have string based notes
    let notes;
    if (Array.isArray(obj.notes)) {
      notes = obj.notes;
    } else {
      notes = obj.turfnotes;
    }

    if (Array.isArray(notes) && notes.length) {
      notes = notes.filter((d) => d.category === noteTagFilter.category);
      if (notes.length) {
        if (noteTagFilter.note && noteTagFilter.note.length) {
          let notestring = notes.reduce((r, d) => `${r} ${d.note}`, "");
          return notestring
            .toLowerCase()
            .includes(noteTagFilter.note.toLowerCase());
        } else {
          return true;
        }
      }
    }

    return false;
  };

  return filter(items, predicate);
};
